<div class="language-container" [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }">
  <p-tree
      [value]="[tree]"
      [filter]="true"
      filterBy="searchableText"
      filterMode="contains"
      containerStyleClass="w-full"
      [emptyMessage]="('iaa.emptySearchMessage' | translate) "
      selectionMode="single"
      [filterInputAutoFocus]="false"
      scrollHeight="300px"
      [autofocus]="false"
      [styleClass]="'plus-icon'"
      class="w-full md:w-30rem"
      [(expandedKeys)]="expandedKeys"
      (onNodeSelect)="handleSelection($event)"
  >
      <ng-template pTemplate="filtericon" let-filter>
          <i class="pi pi-search search-icon"
             [ngStyle]="currentLanguage === 'en' ? { 'margin-right': '5px', 'margin-left': '0', 'transform': 'scaleX(-1)' } : { 'margin-left': '5px', 'margin-right': '0', 'transform': 'scaleX(1)' }">
          </i>
      </ng-template>
      <ng-template let-node pTemplate="default">
          <div class="item">
              <div>{{ node.multiLangLabel | translateLang | async }}</div>
              <div *ngIf="!node.selected" class="hover-text">
                  <i class="pi pi-plus add-remove-icon"></i> {{'iaa.general.add' | translate }}
              </div>
              <div *ngIf="node.selected" class="hover-text">
                  <i class="pi pi-times add-remove-icon"></i> {{'iaa.general.remove' | translate }}
              </div>
          </div>
      </ng-template>
  </p-tree>
</div>
